import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { GlobalProvider } from 'src/services/global';

@Component({
    templateUrl: './image.component.html',
    standalone: false
})
export class ImageComponent implements OnInit {
  @Input() oneImage;
  // @Input() images;
  constructor(public g: GlobalProvider) {}
  async ngOnInit(): Promise<void> {}
}
